import React, {useState, useEffect } from 'react';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import {
  Button
}  from 'react-bootstrap';
import ModalCameraError from './modalCameraError';

function CameraSection (props) {
  
    const [idealFacingMode, setIdealFacingMode] = useState(FACING_MODES.ENVIRONMENT);
    const [isMaxResolution, setIsMaxResolution] = useState(true);
    const [modal, setModal] = useState(false);

    //const [image, setImage] = useState(null);

    function renderButtons () {
      console.log(idealFacingMode)
      if(idealFacingMode === FACING_MODES.USER){
        setIdealFacingMode(FACING_MODES.ENVIRONMENT);
        setIsMaxResolution(true);
      }
      else{
        setIdealFacingMode(FACING_MODES.USER);
        setIsMaxResolution(false);
      }
        
    }

    useEffect(() => {
      
    },[])

    const style={
        position: 'absolute',
        textAlign: 'center',
        top: 35,
        width: '100%',
        MozUserSelect: "none",
        WebkitUserSelect: "none",
        msUserSelect: "none",
    }
    const style1={
        background: 'rgb(255 255 255 / 0.6)',
        color: 'red',
        fontSize: 20,
        fontWeight: 600,
    }
    const style_={
      position: 'absolute',
      textAlign: 'right',
      
      bottom:'44%',
      left:'88%',
      MozUserSelect: "none",
      WebkitUserSelect: "none",
      msUserSelect: "none",
}
  const style_1={
      color: 'red',
      fontSize: 15,
      fontWeight: 600,
  }

    const style2={
      position: 'absolute',
      paddingLeft:25,
      top: '32%',
      MozUserSelect: "none",
      WebkitUserSelect: "none",
      msUserSelect: "none",
  }
  // const style3={
  //     textAlign: 'center',
      
  // }

    function handleTakePhoto (dataUri) {
        // Do stuff with the photo...
        //console.log(dataUri);
        props.setImage(dataUri);
        // fetch(dataUri)
        //   .then(res => res.blob())
        //   .then(blob => {
        //     const file = new File([blob], "amrit",{ type: "image/jpeg" })
        //     setImage(file);
        //     console.log(file);
            
        // })
        //console.log('takePhoto');
    }
     
    const handleCameraError = (e) =>{
      console.log(e, "Asdsad");
      if(e){
        setModal(true);
      }
      else{
        setModal(false);
      }
    }

    return (
      <>
        <div>
            
            <Camera
                idealFacingMode = {idealFacingMode}
                // isMaxResolution = {isMaxResolution}
                idealResolution = {{width: 1792, height: 828}}
                imageType = {IMAGE_TYPES.JPG}
                isImageMirror={false}
                imageCompression = {0.97}
                onCameraError= {(e) =>{handleCameraError(e)}}
                onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
            />
            <div style={style}>
              <div style={style1}>{props.title}.</div>
            </div>
            {/* <div style={style_}>
              <div style={style_1}>Click here</div>
            </div> */}
            <div style={style2}>
                <Button variant="info"style={{fontSize: 22}} onClick={renderButtons}><i class="fa fa-refresh"></i></Button>
            </div>
        </div>
        <ModalCameraError modal={modal} handleClose={() => setModal(false)} />  
      </>
        
    );
}
 
export default CameraSection;